import script from "./forum_landing.vue?vue&type=script&setup=true&lang=js"
export * from "./forum_landing.vue?vue&type=script&setup=true&lang=js"

import "./forum_landing.vue?vue&type=style&index=0&id=06f7520c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f7520c"]])

export default __exports__